import { CModal, BtnLoader } from "../index";

export declare type InputProps = {
    visible: boolean;
    setVisible: (text: boolean) => void;
    onOk: () => void;
    loading: boolean;
}

export const ModalDelete = ({ visible, setVisible, onOk, loading }: InputProps) => {

    return (
        <CModal visible={visible} setVisible={setVisible} radius={'10px'} uId="Mo-deleteRoll" >
            <div className=" w-full flex flex-col p-4">
                <span className="font-bold mb-3">حذف آیتم</span>
                <span className="text-gray-800">آیا از انجام این عملیات اطمینان دارید؟ </span>
                <div className="flex justify-end mt-[40px]">


                    <button type={'button'} onClick={() => { setVisible(false) }} className="w-[80px] mx-2 h-10 bg-dayan-gray-200  flex items-center justify-center rounded-[5px] text-white">
                        <span>خیر</span>
                    </button>
                    {loading ?
                        <button type={'button'} className=" w-[80px] mx-2 h-10 bg-dayan-orange-50  flex items-center justify-center rounded-[5px] text-white relative cursor-not-allowed">
                            <span><BtnLoader /></span>
                        </button>
                        :
                        <button type={'button'} onClick={() => onOk?.()} className=" w-[80px] mx-2 h-10 bg-dayan-orange-50  flex items-center justify-center rounded-[5px] text-white">
                            <span>بله</span>
                        </button>
                    }
                </div>
            </div>
        </CModal>
    );
}